import { BadgeCheck, Star } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";
import { REVIEWS } from "@/data/reviews";

function ReviewCard({ r }) {
  return (
    <figure
      data-testid={`review-card-${r.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className="w-80 sm:w-96 shrink-0 bg-white/80 border border-sand rounded-3xl p-6 sm:p-7 flex flex-col gap-4 shadow-[0_16px_36px_-24px_rgba(44,34,30,0.35)]"
    >
      <div className="flex items-center justify-between">
        <span className="flex text-amberbrand">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} size={14} fill="currentColor" strokeWidth={0} />
          ))}
        </span>
        <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-sage">
          <BadgeCheck size={13} /> Verified purchase
        </span>
      </div>
      <blockquote className="text-sm sm:text-base text-walnutsoft leading-relaxed">
        <strong className="block font-display font-bold text-walnut mb-1.5">“{r.title}”</strong>
        {r.text}
      </blockquote>
      <figcaption className="mt-auto pt-3 border-t border-sand/70 flex items-center justify-between gap-3">
        <span className="text-xs font-semibold text-walnut">{r.name} · {r.date}</span>
        <span className="text-[10px] font-mono uppercase tracking-wider text-walnutmuted text-right">{r.book}</span>
      </figcaption>
    </figure>
  );
}

export default function Reviews() {
  return (
    <section data-testid="reviews-section" className="py-24 sm:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div>
            <Eyebrow className="mb-4">Five stars, every time</Eyebrow>
            <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-walnut">
              Loved by little readers
            </h2>
          </div>
          <p className="max-w-sm text-sm sm:text-base text-walnutsoft leading-relaxed">
            Every verified Amazon UK review for the Bailey series is five stars.
            Here's what families and grandparents say.
          </p>
        </Reveal>
      </div>

      <div className="marquee-pause relative" data-testid="reviews-carousel">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-32 z-10 bg-gradient-to-r from-cream to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-32 z-10 bg-gradient-to-l from-cream to-transparent" />
        <div className="flex w-max animate-marquee" style={{ animationDuration: "70s" }}>
          {[0, 1].map((half) => (
            <div key={half} className="flex shrink-0 gap-6 pr-6">
              {REVIEWS.map((r, i) => (
                <ReviewCard key={`${half}-${i}`} r={r} />
              ))}
            </div>
          ))}
        </div>
      </div>

      <p className="text-center mt-10">
        <a
          href="https://www.amazon.co.uk/s?k=damali+allison"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="reviews-amazon-link"
          className="text-sm font-semibold text-terracotta hover:text-terracottadark transition-colors"
        >
          Read all reviews on Amazon UK →
        </a>
      </p>
    </section>
  );
}
